import { supabase } from '../../adapters/database/supabaseClient'

/**
 * Cash payments may be confirmed by the authorised operator/cashier flow.
 * Card-present payments must NEVER be marked paid from the web client.
 * They are completed only after a verified native/provider transaction result.
 */
export async function registerCashPayment(input: { eventId: string; orderId: string; amountCents: number }) {
  const { data, error } = await supabase.from('payments').insert({
    event_id: input.eventId,
    order_id: input.orderId,
    channel: 'cashier',
    method: 'cash',
    provider: 'cash',
    amount_cents: input.amountCents,
    status: 'paid',
    external_reference: `CASH-${input.orderId}`,
    metadata: { channel: 'cashier' },
    paid_at: new Date().toISOString(),
  }).select('id,status,method,provider,amount_cents').single()
  if (error) throw error
  return data
}

export type NativeTapPaymentIntent = {
  eventId: string
  orderId: string
  paymentId: string
  amountCents: number
  channel: 'cashier' | 'operator'
}

/**
 * Intentionally no `markTapPaymentPaid()` client helper.
 * A successful SDK callback is evidence to send to the trusted backend;
 * the backend/provider verification owns the transition to `paid` and the
 * subsequent production enqueue.
 */
export function nativeTapReference(input: NativeTapPaymentIntent) {
  return `EP-TTP-${input.paymentId}`
}
